enum LicenseTabs {
    PUBLIC = "public",
    ENTERPRISE = "enterprise",
}

export default LicenseTabs;
